import React from 'react'
import { Image } from '@shared/components/image'
import { useMedia } from 'use-media'

import { Back } from '../Back'

import styles from './styles.module.scss'

const Actions = () => {
	const isTablet = useMedia({ minWidth: '768px' })

	return (
		<article className={styles.article}>
			<Back />
			<h1 className={styles.heading}>Работа со сбережением</h1>
			<nav className={styles.nav}>
				<ul>
					<li className={styles.navItem}>
						<a className={styles.link} href='#history'>
							История сбережений в личном кабинете
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#documents'>
							Документы по сделанному сбережению
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#replenishment'>
							Пополнение
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#withdraw-money'>
							Вывод средств
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#change-program'>
							Смена программы
						</a>
					</li>
				</ul>
			</nav>
			<h3 id='work' className={styles.title}>
				История сбережений в личном кабинете
			</h3>
			<p className={styles.paragraph}>
				Посмотреть все условия сбережений, а также историю начислений, выплаты процентов и кешбэка
				можно в личном кабинете инвестора на сайте Credit.Club или в приложении.
			</p>
			<Image name={isTablet ? 'history-t.jpg' : 'history-m.png'} alt='скриншот истории платежей' />

			<h3 id='documents' className={styles.title}>
				Документы по сделанному сбережению
			</h3>
			<p className={styles.paragraph}>
				Все документы по сделки будут храниться в личном кабинете инвестора на вкладке «Документы»:
			</p>
			<Image
				name={isTablet ? 'documents-t.jpg' : 'documents-m.png'}
				alt='скриншот подписания документов'
			/>

			<h3 id='replenishment' className={styles.title}>
				Пополнение
			</h3>
			<p className={styles.paragraph}>
				Пополняются сбережения через личный кабинете инвестора. На вкладке «Главная» под основной
				информацией об условиях сбережения будет кнопка «Пополнить». Перевести деньги на счёт можно
				через QR код — отсканировать его в в банковском приложении, чтобы реквизиты заполнились
				автоматически.
			</p>
			<Image
				name={isTablet ? 'refill-t.jpg' : 'refill-m.png'}
				alt='скриншот пополнения сбережения'
			/>

			<h3 id='withdraw-money' className={styles.title}>
				Вывод средств
			</h3>
			<p className={styles.paragraph}>
				По договору деньги сберегателя выводятся со счёта Фонда не позднее, чем через 30 дней с
				момента обращения клиента. Но чаще всего сбережения переводятся в течение нескольких дней
				после запроса.
			</p>

			<h3 id='change-program' className={styles.title}>
				Смена программы
			</h3>
			<p className={styles.paragraph}>Чтобы поменять программу, нужно открыть новое сбережение.</p>
			<Image
				name={isTablet ? 'change-payment-t.jpg' : 'change-payment-m.png'}
				alt='скриншот смены программы'
			/>
		</article>
	)
}

export default Actions
